export default {"src":"/_next/static/media/envelope-open.90e95a81.svg","height":177,"width":192};